import { updateScoreDisplay, loggedIn } from "./app.js";
import { set, get } from "./state.js";
import { log } from "./log.js";
import { addQuestionsElement, resetQuestionAnswers } from "./questions.js";
import useAuth from "./firebase.js";
import useGrpc from "./grpc.js";

const auth = useAuth();
const grpc = useGrpc();

let activePlayer = null;
let listenEvent = null;
let currentLightbox = null;

function audioEnded(evt) {
  console.log(evt.target);
  listenEvent = evt;
  currentLightbox = buildLightbox(document.body);
}

function buildLightbox(parentElement) {
  const lightboxWrapper = document.createElement("div");
  lightboxWrapper.style.position = "fixed";
  lightboxWrapper.style.top = 0;
  lightboxWrapper.style.bottom = 0;
  lightboxWrapper.style.left = 0;
  lightboxWrapper.style.right = 0;
  lightboxWrapper.style.backgroundColor = "rgba(0,0,0,0.6)";
  lightboxWrapper.style.zIndex = "10001";
  lightboxWrapper.style.padding = "5rem";
  lightboxWrapper.style.textAlign = "center";

  parentElement.appendChild(lightboxWrapper);

  addQuestionsElement(lightboxWrapper, rewardPoints);

  const lightboxClose = document.createElement("h3");
  lightboxClose.textContent = "&times;";
  lightboxClose.zIndex = "10002";
  lightboxClose.color = "white";
  lightboxClose.style.position = "absolute";
  lightboxClose.style.top = 20;
  lightboxClose.style.right = 20;
  lightboxClose.style.padding = "10px";
  lightboxClose.style.fontSize = "24px";
  lightboxClose.style.cursor = "pointer";
  lightboxClose.onclick = (e) => {
    document.body.removeChild(lightboxWrapper);
  };

  lightboxWrapper.appendChild(lightboxClose);

  return lightboxWrapper;
}

function cleanup() {
  resetQuestionAnswers();

  if (currentLightbox != null) {
    currentLightbox.remove();
    currentLightbox = null;
  }

  //   return resp;
}

function rewardPoints(answers) {
  if (!loggedIn()) {
    return;
  }

  if (Object.keys(answers).length < 2) {
    return;
  }

  log("Answers: " + answers);

  const score = Math.floor(listenEvent.target.duration / 60);
  const podcastURL = listenEvent.target.src;

  console.log("Score for podcast: " + score);
  console.log("URL for podcast is: " + podcastURL);

  if (get("accountType") == "0") {
    auth
      .ready()
      .then(() =>
        grpc
          .listenedPodcast(
            podcastURL,
            Object.values(answers).map((ans) => (ans === "YES" ? "Yes" : "No"))
          )
          .then((res) => {
            console.log(res);

            set("score", res.newScore);
            updateScoreDisplay();
            addBadgesToPodcasts();
            cleanup();
          })
      )
      .catch(networkError);
  } else {
    cleanup();
  }
}

function networkError(error) {
  alertify.error("Network error! Please try again.");
  console.error(error);
}

const getPodId = (podcastURL) => {
  // take everything after the last slash
  // remove any query parameters if exists

  const lastSlash = podcastURL.lastIndexOf("/");
  const lastQuestionMark = podcastURL.lastIndexOf("?");
  const id = podcastURL.substring(
    lastSlash + 1,
    lastQuestionMark === -1 ? podcastURL.length : lastQuestionMark
  );

  return id;
};

const addBadgesToPodcasts = async () => {
  playlog = await grpc.getUserPlayLog();

  for (let podcast of document.querySelectorAll(".mejs-container audio")) {
    const item = playlog.playedList.find(
      (p) => getPodId(p.url) === getPodId(podcast.src)
    );

    if (item) {
      jQuery(podcast)
        .parents(".mejs-container")
        .css({
          position: "relative",
        })
        .append(
          `<div class="itp-video-played-badge" style="padding: 2px; background: green; color: white; position: absolute; top:-25px; left:0; font-size: 12pt;"><span>Completed - ${item.score} points earned</span></div>`
        );
    }
  }
};

export function podcast() {
  // hide player controls
  for (let audio of document.querySelectorAll(".mejs-time-rail")) {
    audio.hidden = true;
  }

  //   for (let audio of document.querySelectorAll(".mejs-mediaelement audio")) {
  //     audio.onended = audioEnded;
  //   }

  for (let audio of document.querySelectorAll("audio")) {
    audio.onended = audioEnded;
    audio.onplay = () => {
      activePlayer = audio;
    };
  }

  auth.ready().then(() => {
    jQuery(document).ready(async () => {
      const playlog = await grpc.getUserPlayLog();
      console.log(playlog);

      // make sure podcast cant skip ahead
      jQuery(".mejs-time-rail").css({
        "pointer-events": "none",
      });

      for (let podcast of document.querySelectorAll(".mejs-container audio")) {
        const item = playlog.playedList.find(
          (p) => getPodId(p.url) === getPodId(podcast.src)
        );

        if (item) {
          jQuery(podcast)
            .parents(".mejs-container")
            .css({
              position: "relative",
            })
            .append(
              `<div class="itp-video-played-badge" style="padding: 2px; background: green; color: white; position: absolute; top:-25px; left:0; font-size: 12pt;"><span>Completed - ${item.score} points earned</span></div>`
            );
        }
      }
    });
  });

  jQuery(document).ready(function () {
    window.addEventListener("focus", () => activePlayer?.play());
    window.addEventListener("blur", () => activePlayer?.pause());
  });
}

export default {};
